mutation CreateLead($input: LeadCreateInput!) {
    leadCreate(input: $input) {
        id
        htmlUrlPath
    }
}
